import React from 'react';
import { FiUsers, FiShoppingCart, FiFileText, FiDollarSign, FiActivity } from 'react-icons/fi';
import { Link } from 'react-router-dom';

export default function Dashboard() {
  const stats = [
    { title: 'Total Third-Parties', value: '6', icon: FiUsers, color: 'bg-blue-100 text-blue-600', link: '/crm/third-parties' },
    { title: 'Pending Orders', value: '0', icon: FiShoppingCart, color: 'bg-orange-100 text-orange-600', link: '/sales/orders' },
    { title: 'Unpaid Invoices', value: '1', icon: FiFileText, color: 'bg-red-100 text-red-600', link: '/sales/records' },
    { title: 'Monthly Revenue', value: '$0', icon: FiDollarSign, color: 'bg-green-100 text-green-600', link: '/accounting/income' },
  ];

  const recentActivity = [];

  return (
    <div className="p-6 bg-gray-50 min-h-full font-sans">
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-[#0000a0] mb-1">Welcome back, Wan Yee!</h1>
        <p className="text-gray-500 text-sm">Here is what's happening with WY Limited today.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        {stats.map((stat, idx) => (
          <Link key={idx} to={stat.link} className="bg-white p-5 rounded-lg shadow-sm border border-gray-200 hover:shadow-md transition-shadow flex items-center space-x-4 cursor-pointer">
            <div className={`p-4 rounded-full ${stat.color}`}>
              <stat.icon className="text-2xl" />
            </div>
            <div>
              <p className="text-gray-500 text-xs font-bold uppercase tracking-wider mb-1">{stat.title}</p>
              <p className="text-2xl font-black text-gray-800">{stat.value}</p>
            </div>
          </Link>
        ))}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-5">
          <div className="flex items-center space-x-2 mb-4 pb-3 border-b border-gray-100">
            <FiActivity className="text-teal-600 text-lg" />
            <h2 className="text-lg font-bold text-gray-800">Recent Activity</h2>
          </div>
          <div className="space-y-4">
            {recentActivity.length === 0 && (
              <div className="text-gray-400 italic text-sm py-2">No recent activity.</div>
            )}
          </div>
        </div>

        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-5">
          <div className="flex items-center space-x-2 mb-4 pb-3 border-b border-gray-100">
            <FiFileText className="text-blue-600 text-lg" />
            <h2 className="text-lg font-bold text-gray-800">Quick Actions</h2>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <Link to="/sales/proposals" className="p-3 border border-gray-200 rounded text-center hover:bg-blue-50 hover:border-blue-200 transition-colors text-sm font-bold text-gray-700">
              + New Proposal
            </Link>
            <Link to="/invoice/customer" className="p-3 border border-gray-200 rounded text-center hover:bg-blue-50 hover:border-blue-200 transition-colors text-sm font-bold text-gray-700">
              + New Invoice
            </Link>
            <Link to="/crm/third-parties" className="p-3 border border-gray-200 rounded text-center hover:bg-blue-50 hover:border-blue-200 transition-colors text-sm font-bold text-gray-700">
              + Add Customer
            </Link>
            <Link to="/pos" className="p-3 border border-gray-200 rounded text-center hover:bg-blue-50 hover:border-blue-200 transition-colors text-sm font-bold text-gray-700">
              Launch POS
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}